export const regionArr = [
  "Asia",
  "Africa",
  "Europe",
  "Oceania",
  "North%20America",
  "South%20America",
];

export const regionArrFixed = [
  "Asia",
  "Africa",
  "Europe",
  "Oceania",
  "North America",
  "South America",
];
